import api from "@/config/api"

export default {
  namespaced: true,
  state: () => ({
    pendingCount: 0
  }),
  mutations: {
    setPendingCount(state, count) {
      state.pendingCount = count
    }
  },
  actions: {
    async fetchPendingCount(context) {
      try {
        const response = await api.get("/user_unavailabilities/pending_count")
        context.commit("setPendingCount", response.data.count ?? 0)
      } catch (error) {
        // фича может быть недоступна (нет compliance) — молча оставляем 0
        context.commit("setPendingCount", 0)
      }
    }
  }
}
